import React from "react";
import "../../styles/styles.css";
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pages = [];

  // Generate page numbers and add ellipses as needed
  const getPages = () => {
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1); // Always show the first page
      if (currentPage > 3) pages.push("..."); // Show ellipsis before middle
      const start = Math.max(currentPage - 1, 2);
      const end = Math.min(currentPage + 1, totalPages - 1);
      for (let i = start; i <= end; i++) {
        if (i !== 1 && i !== totalPages) pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push("..."); // Show ellipsis after middle
      pages.push(totalPages); // Always show the last page
    }
  };

  getPages();

  return (
    <div className="pagination">
      {pages.map((page, index) => (
        <button
          key={index}
          onClick={() => {
            if (page !== "...") onPageChange(page);
          }}
          className={`pagination-btn ${page === currentPage ? "active" : ""}`}
          disabled={page === "..."}
        >
          {page}
        </button>
      ))}
    </div>
  );
};

export default Pagination;
